import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/logo3.png'


const _withScopeId = n => (_pushScopeId("data-v-2233d114"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "领航者LOGO"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_system_menu_infinite_item = _resolveComponent("app-system-menu-infinite-item")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createBlock(_component_el_menu, _mergeProps({
    class: "app-system-menu",
    "unique-opened": true,
    "default-active": _ctx.active,
    "default-openeds": _ctx.openeds,
    collapse: _ctx.isCollapse,
    router: true
  }, _ctx.$attrs), {
    default: _withCtx(() => [
      _hoisted_1,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.homeMenus, (menu) => {
        return (_openBlock(), _createBlock(_component_app_system_menu_infinite_item, {
          menu: menu,
          key: menu.path,
          class: "out-menu"
        }, null, 8, ["menu"]))
      }), 128)),
      _createVNode(_component_el_divider, { class: "divider" }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (menu) => {
        return (_openBlock(), _createBlock(_component_app_system_menu_infinite_item, {
          menu: menu,
          key: menu.path,
          class: "out-menu"
        }, null, 8, ["menu"]))
      }), 128))
    ]),
    _: 1
  }, 16, ["default-active", "default-openeds", "collapse"]))
}